<template>
	<v-app>
		<dashboard-core-app-bar v-model="expandOnHover" />

		<dashboard-core-drawer :expand-on-hover.sync="expandOnHover" />

		<dashboard-core-view />

		<dashboard-core-settings v-model="expandOnHover" />
		<transition name="shadow">
			<span
				v-show="drawer == false"
				class="shadow"
				@click="drawer = true;"
				:class="{'shadow-transition' : drawer == false}"
			></span>
		</transition>
	</v-app>
</template>

<script>
	// Utilities
	import { mapState, mapMutations } from "vuex";

	export default {
		name: "DashboardIndex",

		components: {
			DashboardCoreAppBar: () => import("./components/core/AppBar"),
			DashboardCoreDrawer: () => import("./components/core/Drawer"),
			DashboardCoreSettings: () => import("./components/core/Settings"),
			DashboardCoreView: () => import("./components/core/View")
		},

		data: () => ({
			expandOnHover: false
		}),

		watch: {},

		computed: {
			...mapState(["drawer"]),
			drawer: {
				get() {
					return this.$store.state.drawer;
				},
				set(val) {
					this.$store.commit("SET_DRAWER", val);
				}
			}
		},
		methods: {
			...mapMutations({
				setDrawer: "SET_DRAWER"
			})
		}
	};
</script>
